export const SEARCH_TABLER_OPTS = {
  categories: [
    { value: 'prc1', label: '재료입고' },
    { value: 'prc3', label: '조립' },
    { value: 'prc4', label: '품질검사' },
    { value: 'prc5', label: '포장준비' },
    { value: 'prc6', label: '제품포장' },
    { value: 'prc7', label: '출고' },
    { value: 'prc8', label: '운송' },
    { value: 'prc9', label: '판매점입고' },
  ],
  eventTypes: [
    { value: 'ObjectEvent', label: 'ObjectEvent' },
    { value: 'AggregationEvent', label: 'AggregationEvent' },
    { value: 'TransactionEvent', label: 'TransactionEvent' },
    { value: 'TransformationEvent', label: 'TransformationEvent' },
    { value: 'AssociationEvent', label: 'AssociationEvent' },
  ],
  actions: [
    { value: 'add', label: 'Add' },
    { value: 'delete', label: 'Delete' },
    { value: 'observe', label: 'Observe' },
  ],
  bizSteps: [
    { value: 'RECEIVING', label: 'Receiving' },
    { value: 'ASSEMBLING', label: 'Assembling' },
    { value: 'INSPECTING', label: 'Inspecting' },
    { value: 'COMMISSIONING', label: 'Commissioning' },
    { value: 'PACKING', label: 'Packing' },
    { value: 'UNPACKING', label: 'Unpacking' },
    { value: 'SHIPPING', label: 'Shipping' },
    { value: 'TRANSPORTING', label: 'Transporting' },
    { value: 'DESTROYING', label: 'Destroying' },
  ],
  dispositions: [
    { value: 'IN_PROGRESS', label: 'InProgress' },
    { value: 'ACTIVE', label: 'Active' },
    { value: 'INACTIVE', label: 'InActive' },
    { value: 'IN_TRANSIT', label: 'In_transit' },
    { value: 'AVAILABLE', label: 'Available' },
    { value: 'DESTROYED', label: 'Destroyed' },
    { value: 'RESERVED', label: 'Reserved' },
  ],
}
